import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Emoji } from '@atlaskit/editor-common/emoji';
// eslint-disable-next-line
var clickSelectWrapperStyle = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage\n  user-select: all;\n"])));
export default function EmojiNode(props) {
  return jsx("span", {
    css: clickSelectWrapperStyle
  }, jsx(Emoji, props));
}